<!--
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
-->
<template>
  <a
    v-if="href"
    ref="btn_input"
    class="btn"
    :class="btnClass"
    :href="href"
    :disabled="disabled"
    :data-qa="dataQa"
    @click="onClick"
  >
    <svg-icon
      v-if="icon"
      :icon="icon"
      :data-qa="dataQa ? `${dataQa}_left_icon` : null"
    />
    <img
      v-if="imageSrc"
      :src="imageSrc"
      :data-qa="dataQa ? `${dataQa}_img` : null"
    >
    {{ text }}
    <select
      v-if="select && selectOptions"
      :data-qa="dataQa ? `${dataQa}_select` : null"
    >
      <option
        v-for="(option,index) in selectOptions"
        :key="index"
        :value="option.value"
      >{{ option.text }}</option>
    </select>
    <slot />
    <svg-icon
      v-if="iconRight"
      :icon="iconRight"
      :data-qa="dataQa ? `${dataQa}_right_icon` : null"
    />
  </a>
  <div
    v-else-if="call"
    ref="btn_input"
    class="call-btn"
    :class="{success:type === 'success', danger:type === 'danger'}"
    :data-qa="dataQa"
    @click="onClick"
  >
    <div
      class="call-btn-border"
      :data-qa="dataQa ? `${dataQa}_btn_border` : null"
    >
      <button
        :type="btnType"
        class="btn"
        :class="btnClass"
        :disabled="disabled"
        :data-qa="dataQa ? `${dataQa}_btn` : null"
      >
        <svg-icon
          v-if="icon"
          :icon="icon"
          :data-qa="dataQa ? `${dataQa}_left_icon` : null"
        />
        <img
          v-if="imageSrc"
          :src="imageSrc"
          :data-qa="dataQa ? `${dataQa}_img` : null"
        >
        {{ text }}
        <select
          v-if="select && selectOptions"
          :data-qa="dataQa ? `${dataQa}_select` : null"
        >
          <option
            v-for="(option,index) in selectOptions"
            :key="index"
            :value="option.value"
          >
            {{ option.text }}
          </option>
        </select>
        <slot />
        <svg-icon
          v-if="iconRight"
          :icon="iconRight"
          :data-qa="dataQa ? `${dataQa}_right_icon` : null"
        />
      </button>
    </div>
    <h5
      v-if="label"
      :data-qa="dataQa ? `${dataQa}_label` : null"
    >
      {{ label }}
    </h5>
  </div>
  <button
    v-else
    ref="btn_input"
    :type="btnType"
    class="btn"
    :class="btnClass"
    :disabled="disabled"
    :data-qa="dataQa"
    @click="onClick"
  >
    <svg-icon
      v-if="icon"
      :icon="icon"
      :data-qa="dataQa ? `${dataQa}_left_icon` : null"
    />
    <img
      v-if="imageSrc"
      :src="imageSrc"
      :data-qa="dataQa ? `${dataQa}_img` : null"
    >
    {{ text }}
    <select
      v-if="select && selectOptions"
      :data-qa="dataQa ? `${dataQa}_select` : null"
    >
      <option
        v-for="(option,index) in selectOptions"
        :key="index"
        :value="option.value"
      >
        {{ option.text }}
      </option>
    </select>
    <slot />
    <svg-icon
      v-if="iconRight"
      :icon="iconRight"
      :data-qa="dataQa ? `${dataQa}_right_icon` : null"
    />
  </button>
</template>

<script>
export default {
  name: 'FormButton',
  props: {
    btnType: {
      type: String,
      default: 'button'
    },
    call: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    link: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    iconRight: {
      type: String,
      default: null
    },
    imageSrc: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    href: {
      type: String,
      default: null
    },
    select: {
      type: Boolean,
      default: false
    },
    selectOptions: {
      type: Array,
      default: null
    },
    dataQa: {
      type: String,
      default: null
    }
  },
  computed: {
    btnClass () {
      let clas = '';
      if (this.rounded) {
        clas = 'btn-nav ';
      } else if (this.link) {
        clas = 'btn-link ';
      }

      switch (this.type) {
        case 'primary':
          clas += 'btn-primary';
          break;
        case 'success':
          clas += 'btn-success';
          break;
        case 'danger':
          clas += 'btn-danger';
          break;
        case 'ctrl':
          clas += 'btn-ctrls';
          break;
        case 'user-ctrl':
          clas += 'btn-user-ctrl';
          break;
      }
      return clas;
    }
  },
  methods: {
    onClick (evt) {
      this.$emit('onClick', evt);
    },
    focusIn () {
      if (this.$refs.btn_input) {
        this.$refs.btn_input.focus();
      }
    }
  }
};
</script>

<style scoped>
</style>
